import { useCallback, useSyncExternalStore } from 'react'
import { isSSR } from 'lib/helpers/isSSR/isSSR'

/**
 * A custom hook that returns a boolean indicating whether the code is being executed on the server or the client.
 * It uses the `useSyncExternalStore` hook to synchronize the state between the client and the server.
 * @returns {boolean} A boolean indicating whether the code is being executed on the server or the client.
 */
export const useIsSSR = (): boolean => {
  const init = useCallback((callback: () => void) => callback, [])
  const getClientState = useCallback(() => isSSR(), [])
  const getServerState = useCallback(() => true, [])

  return useSyncExternalStore(init, getClientState, getServerState)
}
